/** Render a list of strings as one item per line (used on the review/thank-you pages
 *  for fields like excluded classes and Section 125 plans/tiers). */
export const stackedList = (items: string[]): React.ReactNode =>
  items.length === 0 ? "" : <>{items.map((it, i) => <div key={i}>{it}</div>)}</>;
